// 미디어 관리 관련 타입 정의

// 노출 상태 타입
export type ExposureType = 'show' | 'hide';
export type ExposureDisplayType = '노출' | '비노출';

// 미디어 아이템 인터페이스
export interface MediaItem {
  id: number;
  layoutName: string;
  exposureType: ExposureType;
  startDate?: string | null;
  endDate?: string | null;
  mediaName: string;
  content?: string;
  videoFile?: string;
  videoUrl?: string; // GCS 또는 로컬 저장소의 실제 비디오 URL
  fileSize?: number; // 파일 크기 (바이트)
  createdAt: string;
  updatedAt?: string;
  createdBy?: string;
  updatedBy?: string;
}

// 미디어 목록 응답 인터페이스
export interface MediaListResponse {
  data: MediaItem[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

// 미디어 생성 요청 인터페이스
export interface CreateMediaRequest {
  layoutName: string;
  exposureType: ExposureType;
  startDate?: string | null;
  endDate?: string | null;
  mediaName: string;
  content?: string;
  videoFile: File;
}

// 미디어 수정 요청 인터페이스
export interface UpdateMediaRequest extends Partial<CreateMediaRequest> {
  id: number;
  deleteCurrentFile?: boolean; // 기존 파일 삭제 여부
}

// 미디어 필터 옵션
export interface MediaFilterOptions {
  exposureType?: ExposureType | 'all';
  searchKeyword?: string;
  page?: number;
  limit?: number;
}

// 미디어 관리 유틸리티 함수
export const getExposureDisplayText = (exposureType: ExposureType): ExposureDisplayType => {
  return exposureType === 'show' ? '노출' : '비노출';
};

export const getExposureTypeFromDisplay = (displayType: ExposureDisplayType): ExposureType => {
  return displayType === '노출' ? 'show' : 'hide';
};